"use client";

import { c as _c } from "react/compiler-runtime";
import { useCarousel } from "@/components/ui/carousel";
interface Props {
  total: number;
}
export function GalleryCounter(t0) {
  const $ = _c(3);
  const {
    total
  } = t0;
  const {
    selectedIndex
  } = useCarousel();
  const current = total > 0 ? Math.min(selectedIndex + 1, total) : 0;
  if (total === 0) {
    return null;
  }
  let t1;
  if ($[0] !== current || $[1] !== total) {
    t1 = <div className="flex items-center justify-center py-2"><p className="text-sm text-muted-foreground">Image {current} of {total}</p></div>;
    $[0] = current;
    $[1] = total;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}